import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { PaperProps, cancelSuccess } from 'constants';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { putSessionCancel } from 'layouts/tutoring/services/tutoringApi';
import {
  getDialogHeading,
  renderSaveCancelButtons,
  useNotification,
  fieldValidation,
  emptyFunction,
  onSave,
  refinePayload,
} from 'utils/commonUtils';

const bookedSessionCancelDialogSchema = yup.object().shape({
  cancelNote: fieldValidation(4000),
});

const BookedSessionCancelDialog = (props) => {
  const {
    bookedSessionCancelDialog,
    setBookedSessionCancelDialog,
    sessionId,
    fetchBookedSessions,
  } = props;

  const dispatch = useDispatch();

  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();

  const [loadingButton, setLoadingButton] = useState(false);

  const defaultValue = {
    cancelNote: '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(bookedSessionCancelDialogSchema),
  });

  const { handleSubmit, control, reset, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.cancelNote]);

  const handleClose = () => {
    setBookedSessionCancelDialog(false);
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    const { cancelNote } = data;
    const payload = {
      note: cancelNote,
    };
    onSave(
      cancelSuccess,
      false,
      emptyFunction,
      putSessionCancel,
      refinePayload(payload),
      sessionId,
      fetchBookedSessions,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton
    );
  };

  return (
    <>
      <Dialog open={bookedSessionCancelDialog} PaperProps={PaperProps}>
        {getDialogHeading('Cancel session', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputText
              name="cancelNote"
              type="text"
              control={control}
              label="Note"
              helperText={errors?.cancelNote?.message}
              errors={!!errors.cancelNote}
              multiline
              rows={2}
            />
            <MDBox mt={1}></MDBox>
            {renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loadingButton,
              false
            )}
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default BookedSessionCancelDialog;
